import React, { createContext, useContext, useState } from 'react';

// Criar o contexto
const DialogContext = createContext();

// Provedor do contexto
export const DialogProvider = ({ children }) => {
  const [dialogs, setDialogs] = useState([]);
  const [dialogData, setDialogData] = useState({});

  const openDialog = (dialogId, data) => {
    setDialogData(data);
    setDialogs((prevDialogs) => [...prevDialogs, dialogId]);
  };

  const closeDialog = (dialogId) => {
    setDialogData({});
    setDialogs((prevDialogs) => prevDialogs.filter((id) => id !== dialogId));
  };

  const isDialogOpen = (dialogId) => dialogs.includes(dialogId);

  const value = {
    openDialog,
    closeDialog,
    isDialogOpen,
    dialogData,
  };

  return <DialogContext.Provider value={value}>{children}</DialogContext.Provider>;
};

// Hook personalizado para usar o contexto
/**
 *
 * @param {*} dialogId
 * @returns
 */
export const useDialog = (dialogId) => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('useDialog deve ser usado dentro de DialogProvider');
  }

  const { openDialog, closeDialog, isDialogOpen, dialogData } = context;

  return {
    openDialog: (data) => openDialog(dialogId, data),
    closeDialog: () => closeDialog(dialogId),
    isDialogOpen: () => isDialogOpen(dialogId),
    dialogData,
  };
};
